export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export interface SortingValues<KeyColumns extends string = string> {
  column: KeyColumns;
  order: SortOrder;
}

export const sortDir = <TData>(col: keyof TData, sort?: SortingValues<string>): SortOrder | undefined => {
  if (!sort || sort.column !== String(col)) {
    return undefined;
  }
  return sort.order === SortOrder.Asc ? SortOrder.Asc : SortOrder.Desc;
};
